// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button also uses styles from inputCommon.module.css */

/* Styles for all buttons (including link and custom) */
.root__JgX5GbR8awQUNvf0SpeO {
  cursor: pointer;
  background-color: var(--cp-buttonBg, transparent);
}
.root__JgX5GbR8awQUNvf0SpeO:hover {
  --cp-buttonBg: var(--cp-buttonBgHover, transparent);
}
.root__JgX5GbR8awQUNvf0SpeO:active {
  --cp-buttonBg: var(--cp-buttonBgActive, transparent);
}

/* Styles for default, primary, iconOnly */
.standard__kNx_iOK2UGZihfvlj187 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  user-select: none;
  white-space: nowrap;
  font-weight: 600;
  margin: 0;
}

/* Styles for default and primary (conflicting with link or iconOnly) */
.defaultPrimary__IfHcd_mlcyjQMKFHdEpV {
  padding: 0px 16px;
  min-width: 80px;
}

.default__tiYzESHvbNNoSm4ASCHg {
  --cp-buttonBg: var(--cp-white);
  --cp-buttonBgHover: var(--cp-neutralLighter);
  --cp-buttonBgActive: var(--cp-neutralLight);
}

.primary__cdc4_xoyu5lt350lFjqA {
  --cp-buttonBg: var(--cp-themePrimary);
  --cp-buttonBgHover: var(--cp-themeDarkAlt);
  --cp-buttonBgActive: var(--cp-themeDark);
  --cp-text: var(--cp-white);
  --cp-textHover: var(--cp-white);
  --cp-border: var(--cp-themePrimary);
  --cp-borderHover: var(--cp-buttonBgHover);
  --cp-borderActive: var(--cp-buttonBgActive);
}

.iconOnly__eIL_UrsiGfYnQqwosX2v {
  --cp-buttonBgActive: rgb(var(--cp-blackRgb) / 0.2);
  --cp-buttonBgHover: rgb(var(--cp-blackRgb) / 0.1);
  --cp-border: transparent;
  --cp-borderHover: transparent;
  --cp-inputRadius: 4px;
  width: 32px; /* matches height */
  padding: 0;
}

.link__NZ7Sk5QxxabNggVr0JJY {
  /* blue text (slightly darker to work on light gray backgrounds) */
  --cp-text: var(--cp-themeDarkAlt);
  --cp-textHover: var(--cp-themeDarker);
  /* allow text wrapping */
  display: inline;
  text-align: start;
  margin: 0;
  padding: 0;
  border: none;
  text-decoration: underline;
  font-size: inherit;
  font-weight: inherit;
  /* add space to make file path links more readable */
  text-underline-offset: 2px;
}
.link__NZ7Sk5QxxabNggVr0JJY:focus-visible {
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,uDAAuD;AACvD;EACE,eAAe;EACf,iDAAiD;AACnD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,oDAAoD;AACtD;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,wCAAwC;EACxC,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;EACjD,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW,EAAE,mBAAmB;EAChC,UAAU;AACZ;;AAEA;EACE,kEAAkE;EAClE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,oDAAoD;EACpD,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* Button also uses styles from inputCommon.module.css */\n\n/* Styles for all buttons (including link and custom) */\n.root {\n  cursor: pointer;\n  background-color: var(--cp-buttonBg, transparent);\n}\n.root:hover {\n  --cp-buttonBg: var(--cp-buttonBgHover, transparent);\n}\n.root:active {\n  --cp-buttonBg: var(--cp-buttonBgActive, transparent);\n}\n\n/* Styles for default, primary, iconOnly */\n.standard {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  user-select: none;\n  white-space: nowrap;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Styles for default and primary (conflicting with link or iconOnly) */\n.defaultPrimary {\n  padding: 0px 16px;\n  min-width: 80px;\n}\n\n.default {\n  --cp-buttonBg: var(--cp-white);\n  --cp-buttonBgHover: var(--cp-neutralLighter);\n  --cp-buttonBgActive: var(--cp-neutralLight);\n}\n\n.primary {\n  --cp-buttonBg: var(--cp-themePrimary);\n  --cp-buttonBgHover: var(--cp-themeDarkAlt);\n  --cp-buttonBgActive: var(--cp-themeDark);\n  --cp-text: var(--cp-white);\n  --cp-textHover: var(--cp-white);\n  --cp-border: var(--cp-themePrimary);\n  --cp-borderHover: var(--cp-buttonBgHover);\n  --cp-borderActive: var(--cp-buttonBgActive);\n}\n\n.iconOnly {\n  --cp-buttonBgActive: rgb(var(--cp-blackRgb) / 0.2);\n  --cp-buttonBgHover: rgb(var(--cp-blackRgb) / 0.1);\n  --cp-border: transparent;\n  --cp-borderHover: transparent;\n  --cp-inputRadius: 4px;\n  width: 32px; /* matches height */\n  padding: 0;\n}\n\n.link {\n  /* blue text (slightly darker to work on light gray backgrounds) */\n  --cp-text: var(--cp-themeDarkAlt);\n  --cp-textHover: var(--cp-themeDarker);\n  /* allow text wrapping */\n  display: inline;\n  text-align: start;\n  margin: 0;\n  padding: 0;\n  border: none;\n  text-decoration: underline;\n  font-size: inherit;\n  font-weight: inherit;\n  /* add space to make file path links more readable */\n  text-underline-offset: 2px;\n}\n.link:focus-visible {\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__JgX5GbR8awQUNvf0SpeO`,
	"standard": `standard__kNx_iOK2UGZihfvlj187`,
	"defaultPrimary": `defaultPrimary__IfHcd_mlcyjQMKFHdEpV`,
	"default": `default__tiYzESHvbNNoSm4ASCHg`,
	"primary": `primary__cdc4_xoyu5lt350lFjqA`,
	"iconOnly": `iconOnly__eIL_UrsiGfYnQqwosX2v`,
	"link": `link__NZ7Sk5QxxabNggVr0JJY`
};
export default ___CSS_LOADER_EXPORT___;
